import { useContext } from "preact/hooks";
import { Text } from "preact-i18n";

import { Configs } from "../../helpers/context";
import { formatIntegerCurrencyString } from "../../helpers/formatters";

import ProductImage from "./ProductImage";

const ProductPayLinkRow = ({ product, quantityInCart, onAdd }) => {
  const configsContext = useContext(Configs);

  const price = formatIntegerCurrencyString(
    product.minPrice,
    configsContext?.configs?.currency,
    configsContext?.configs?.ecommerceLocaleLanguage,
  );

  return (
    <div className="ppl-product">
      <div className="ppl-product-picture">
        <ProductImage className="ppl-product-image" src={product.imageUrl} alt={product.name} />
        {quantityInCart ? <div className="ppl-product-count">{quantityInCart}</div> : null}
      </div>
      <div className="ppl-product-info">
        <h3 className="ppl-product-name">{product.name}</h3>
        {product.description ? <p className="ppl-product-description">{product.description}</p> : null}
        <div className="ppl-product-footer">
          <span className="ppl-product-price">
            {product.skus.length > 1 ? (
              <Text id="PRODUCT_PAYLINK_FROM">From</Text>
            ) : null}{" "}
            <strong>{price}</strong>
          </span>
          <button
            type="button"
            className="ppl-add-button"
            onClick={() => onAdd(product)}
            disabled={!product.skus.length}
          >
            <svg className="ppl-add-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true">
              <path d="M12 4v16M4 12h16" />
            </svg>
            <Text id="PRODUCT_PAYLINK_ADD">Add</Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductPayLinkRow;
